// extracted by mini-css-extract-plugin
module.exports = {"variants":"VariantSelector_variants__62QY8","display-name":"VariantSelector_display-name__Hujc1"};